<div class="card dynamic-date-group" *ngIf="hasFrame && taskGroup && taskGroup.tasks">
    <button
        type="button"
        class="card-header dynamic-date-group-header"
        (click)="requestToggle()"
        [attr.aria-expanded]="!isCollapsed"
    >
        <span class="dynamic-group-corner-badges">
            <span class="dynamic-task-type-count dynamic-group-total-count">
                {{ taskGroup.tasks.length }} {{ 'my-tasks.task-count' | translate }}
            </span>
            <span
                class="dynamic-task-type-count dynamic-collecting-task-count"
                [attr.aria-label]="
                    ('my-tasks.collecting-task-count' | translate) +
                    ': ' +
                    collectingTaskCount
                "
            >
                {{ collectingTaskCount }}
            </span>
            <span
                class="dynamic-task-type-count dynamic-delivering-task-count"
                [attr.aria-label]="
                    ('my-tasks.delivering-task-count' | translate) +
                    ': ' +
                    deliveringTaskCount
                "
            >
                {{ deliveringTaskCount }}
            </span>
            <span
                class="dynamic-task-type-count dynamic-refunding-task-count"
                [attr.aria-label]="'ItemsRefunding: ' + refundingTaskCount"
            >
                {{ refundingTaskCount }}
            </span>
        </span>
        <span>{{ taskGroup.deliveryDate | date : dateFormat : '+2' : 'hu-HU' }}</span>
        <span class="dynamic-date-group-meta">
            <i
                class="fa"
                [ngClass]="isCollapsed ? 'fa-angle-down' : 'fa-angle-up'"
                aria-hidden="true"
            ></i>
        </span>
    </button>
    <div
        class="card-body text-center dynamic-task-list"
        [collapse]="isCollapsed"
        [isAnimated]="false"
    >
        <app-task-group-item
            *ngFor="let taskGroupItem of taskGroup.tasks; let taskIndex = index"
            [taskGroupItem]="taskGroupItem"
            [useDynamicRouting]="true"
            [groupCollapsed]="isCollapsed"
            [class.d-none]="hideDone && isDone(taskGroupItem)"
            [badgeText]="showTaskBadges ? getTaskBadgeText(taskIndex) : null"
        ></app-task-group-item>
    </div>
</div>

<ng-container *ngIf="!hasFrame && taskGroup && taskGroup.tasks">
    <div
        class="w-100 text-center"
        [class.dynamic-task-list]="useDynamicRouting"
        [collapse]="isCollapsed"
        [isAnimated]="false"
    >
        <ng-container
            *ngFor="let taskGroupItem of taskGroup.tasks; let taskIndex = index"
        >
            <app-task-group-item
                [taskGroupItem]="taskGroupItem"
                [useDynamicRouting]="true"
                [groupCollapsed]="isCollapsed"
                [class.d-none]="hideDone && isDone(taskGroupItem)"
                [badgeText]="showTaskBadges ? getTaskBadgeText(taskIndex) : null"
            ></app-task-group-item>
            <div
                *ngIf="isLastCollectingTaskInSequence(taskIndex)"
                class="picking-deadline-divider"
            >
                <span>
                    {{ 'my-tasks.picking-deadline' | translate }}:
                    {{ getCollectingDeadline(taskIndex) | amDateFormat : 'H:mm' }}
                </span>
            </div>
        </ng-container>
    </div>
</ng-container>
